import { accMenuItems } from "./config/acc.items";
import { macroMenuItems } from "./config/macro.items";
import { presenteeismMenuItems } from "./config/presenteeism.items";

export const menuItems = [...macroMenuItems, ...accMenuItems, ...presenteeismMenuItems];
